import { useEffect } from "react";

export const useAutoScrollToTop = (behavior = "smooth") => {
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior });
  }, [behavior]);
};
